import React, {createContext, useReducer} from "react"
import {ConfigReducer} from "../reducers/ConfigReducer";

export const ConfigContext = createContext()

const model = {
    capability: ''
}

const CapabilityContextProvider = (props) => {
    const [ configViewModel, configDispatch ] = useReducer(ConfigReducer, model)
    return (
        <ConfigContext.Provider value = {{configViewModel, configDispatch}}>
            {props.children}
        </ConfigContext.Provider>
    )
}

export default CapabilityContextProvider



// WEBPACK FOOTER //
// ./src/components/global/context/ConfigContext.js